export const Catalog = [
    {
      path: '/catalog/:app_module_id',
      name: 'catalog.index',
      component: () => import('@/pages/Catalog/CatalogModule')
    },
    {
      path: '/catalog/:app_module_id/:id',
      name: 'catalog.item',
      component: () => import('@/pages/Catalog/CatalogPage')
    },
  ]